import { useCallback, useState } from 'react'

import { storage } from '@/lib/storage'

export type BillFormViewMode = 'classic' | 'hybrid' | 'excel'

const STORAGE_KEY = 'bill-form-view-mode'

function readStoredMode(): BillFormViewMode {
  const raw = storage.get(STORAGE_KEY)
  if (raw === 'excel' || raw === 'hybrid') return raw
  return 'classic'
}

export function useBillFormViewMode() {
  const [viewMode, setViewModeState] = useState<BillFormViewMode>(() => readStoredMode())

  const setViewMode = useCallback((mode: BillFormViewMode) => {
    setViewModeState(mode)
    storage.set(STORAGE_KEY, mode)
  }, [])

  return { viewMode, setViewMode }
}
